(() => {
  const config = JSON.parse(document.getElementById('SwanStockConfig').textContent);
  const root = config.root;
  const showError = (container, text) => {
    let error = container.querySelector('[data-sb-stock-error]');
    if (!error) {
      error = document.createElement('p');
      error.dataset.sbStockError = '';
      error.className = 'sb-stock-warning';
      error.setAttribute('role', 'alert');
      error.tabIndex = -1;
      container.appendChild(error);
    }
    error.textContent = text;
    error.focus();
  };
  window.SwanStock = {
    async canAdd(container) {
      const marker = container.querySelector('[data-sb-stock-blocked]');
      if (marker?.value === 'true') {
        showError(container, config.addWarning);
        return false;
      }
      const url = marker?.dataset.sbProductUrl || container.dataset.sbProductUrl;
      if (!url) {
        showError(container, config.checkFailed);
        return false;
      }
      try {
        const endpoint = new URL(url, location.origin);
        endpoint.pathname += '.js';
        endpoint.search = '';
        const response = await fetch(endpoint, { cache: 'no-store' });
        if (!response.ok) throw new Error('Availability check failed');
        const product = await response.json();
        const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',').map(tag => tag.trim());
        if (tags.includes('out-of-stock')) {
          container.querySelectorAll('.product_form_buy_button').forEach(button => { button.disabled = true; });
          showError(container, config.addWarning);
          return false;
        }
        return true;
      } catch {
        showError(container, config.checkFailed);
        return false;
      }
    }
  };
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form[data-sb-native-product]');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (await window.SwanStock.canAdd(form)) HTMLFormElement.prototype.submit.call(form);
  }, true);
  let checkingCheckout = false;
  document.addEventListener('click', async event => {
    const link = event.target.closest('a[data-sb-checkout-guard]');
    if (!link) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkingCheckout) return;
    checkingCheckout = true;
    link.setAttribute('aria-busy', 'true');
    const cart = link.closest('cart-contents');
    try {
      const response = await fetch(root + '?sections=cart', { cache: 'no-store' });
      if (!response.ok) throw new Error('Cart check failed');
      const sections = await response.json();
      if (!sections.cart) throw new Error('Cart check failed');
      const html = new DOMParser().parseFromString(sections.cart, 'text/html');
      if (html.querySelector('[data-sb-cart-stock-warning]')) {
        showError(cart, config.checkoutWarning);
        return;
      }
      window.location.assign(link.href);
    } catch {
      showError(cart, config.checkFailed);
    } finally {
      checkingCheckout = false;
      link.removeAttribute('aria-busy');
    }
  }, true);
})();
